import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Plus, Settings } from 'lucide-react'
import { templatesApi } from '../services/api'

export default function TemplatesPage() {
  const [selectedType, setSelectedType] = useState<string | undefined>()

  const { data: templates, isLoading } = useQuery({
    queryKey: ['templates', selectedType],
    queryFn: () => templatesApi.list(selectedType).then(r => r.data),
  })

  const documentTypes = [
    { value: undefined, label: 'Wszystkie' },
    { value: 'OpiniaPrawna', label: 'Opinia' },
    { value: 'Pozew', label: 'Pozew' },
    { value: 'Umowa', label: 'Umowa' },
    { value: 'PismoProcesowe', label: 'Pismo procesowe' },
  ]

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Szablony</h1>
          <p className="text-gray-500">Zarządzaj szablonami dokumentów</p>
        </div>
        <button className="btn-primary">
          <Plus className="w-4 h-4 mr-2" />
          Nowy szablon
        </button>
      </div>

      {/* Type filter */}
      <div className="flex gap-2">
        {documentTypes.map((type) => (
          <button
            key={type.value ?? 'all'}
            onClick={() => setSelectedType(type.value)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              selectedType === type.value
                ? 'bg-blue-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50 border'
            }`}
          >
            {type.label}
          </button>
        ))}
      </div>

      {/* Templates grid */}
      {isLoading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {templates?.map((template) => (
            <div key={template.id} className="card p-6 hover:shadow-md transition-shadow">
              <div className="flex items-start justify-between">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Settings className="w-5 h-5 text-blue-600" />
                </div>
                {template.isSystem && (
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                    System
                  </span>
                )}
              </div>
              <h3 className="font-semibold mt-4">{template.name}</h3>
              <p className="text-sm text-gray-500 mt-1">
                {template.description || 'Brak opisu'}
              </p>
              <div className="flex items-center justify-between mt-4 pt-4 border-t">
                <span className="text-xs text-gray-500">
                  Wersja {template.currentVersion}
                </span>
                <button className="text-blue-600 text-sm hover:underline">
                  Edytuj
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
